import ExpenditureCategoriesAppConfig from './expenditureCategories/expenditureCategoriesAppConfig';
import ExpenditureAppConfig from './expenditure/expenditureAppConfig';

const ExpendituresAppConfig = [ExpenditureCategoriesAppConfig, ExpenditureAppConfig];

export default ExpendituresAppConfig;
